import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { style: {"color":"red"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_ctx.showNCalc)
    ? (_openBlock(), _createBlock(_component_v_dialog, {
        key: 0,
        modelValue: _ctx.showNCalc,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showNCalc) = $event)),
        width: "1000",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { "primary-title": "" }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" NCALC Tester ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Parsed formula:", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.parsedFormula), 1)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("strong", null, "Result:", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.output), 1)
                  ]),
                  _createVNode(_component_v_text_field, {
                    label: "NCALC Formula",
                    modelValue: _ctx.formula,
                    "onUpdate:modelValue": [
                      _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formula) = $event)),
                      _ctx.onFormulaChange
                    ],
                    variant: "outlined",
                    clearable: "",
                    class: "mt-3"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variableInputs, (value, variable) => {
                    return (_openBlock(), _createElementBlock("div", { key: variable }, [
                      _createVNode(_component_v_text_field, {
                        label: `Value for ${variable}`,
                        modelValue: _ctx.variableInputs[variable],
                        "onUpdate:modelValue": [($event: any) => ((_ctx.variableInputs[variable]) = $event), _ctx.evaluateFormula],
                        variant: "outlined",
                        clearable: ""
                      }, null, 8, ["label", "modelValue", "onUpdate:modelValue"])
                    ]))
                  }), 128)),
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("span", _hoisted_2, [
                          _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Error:", -1)),
                          _createTextVNode(" " + _toDisplayString(_ctx.error), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.close
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.cancel")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]))
    : _createCommentVNode("", true)
}